import mod from "-!./DesignMarket.js?vue&type=script&lang=js&"; export default mod; export * from "-!./DesignMarket.js?vue&type=script&lang=js&"